import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import Header from "./components/Header";
import Blogs from "./view/Blogs";
import About from "./view/About";
import Contact from "./view/Contact";
import Calculator from "./view/Calculator";
import Error from "./view/Error";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

export { Header, Blogs, Error, About, Contact, Calculator };
